import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { HttpHeaders } from "@angular/common/http";
import { HttpClient, HttpParams } from "@angular/common/http";
import "rxjs/add/operator/toPromise";
import { Contact } from "./contact";
import { ModalService } from "./../../services/modal.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private modalService: ModalService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const PHONE_PATTERN =
      /^\+?(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?|\d[1-9]))$/;

    this.contactForm = this.formBuilder.group({
      Name: ["", Validators.required],
      Email: ["", [Validators.required, Validators.email]],
      Postcode: ["", Validators.required],
      PhoneNumber: ["", Validators.required],
      Message: ["", Validators.required],
    });
  }

  onSubmit() {
    const url = `https://us-central1-newrycab-37e7d.cloudfunctions.net/httpEmail`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    const body = new HttpParams()
      .set("Name", this.contactForm.value.Name)
      .set("Email", this.contactForm.value.Email)
      .set("Postcode", this.contactForm.value.Postcode)
      .set("PhoneNumber", this.contactForm.value.PhoneNumber)
      .set("Message", this.contactForm.value.Message);

    return this.http
      .post(url, body.toString(), {
        headers: headers,
      })
      .subscribe(
        (response) => {
          this.contactForm.reset();
          this.modalService.close("custom-modal-2");
          this.toastr.success(
            "We will be in contact shortly",
            "Referral form received",
            {
              timeOut: 3000,
            }
          );
        },
        (err) => {
          this.contactForm.reset();
          this.modalService.close("custom-modal-2");
          if (err.status === 200) {
            this.toastr.success(
              "We will be in contact shortly",
              "Referral form received",
              {
                timeOut: 3000,
              }
            );
          } else {
            this.toastr.error(
              "Please try again later.",
              "Referral form not submitted",
              {
                timeOut: 3000,
              }
            );
          }
        }
      );
  }

  close() {
    this.contactForm.reset();
    this.modalService.close("custom-modal-2");
  }
}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/contact/contact.component.ts